<template>
  <main>
    <div class="container">
      <!-- 切換標題 -->
      <div class="tab_title" :class="{jp: $region === 'jp'}">
        <router-link :to="{name: 'newsH5'}" class="cate news_title" :class="{jp: $region === 'jp'}">
          <p class="gray">{{$t('active.newsNotice')}}</p>
          <hr>
        </router-link>
        <a class="cate event_title" :class="{jp: $region === 'jp'}">
          <p>{{$t('active.newActive')}}</p>
          <div class="focus_dot"></div>
        </a>
      </div>
      <!-- 活动timeline -->
      <div class="eventsline">
        <div class="event_item" v-for="n in eventList" :key="n.activity_id">
          <div class="img_box" :style="{'backgroundImage':'url('+n.image+')'}"></div>
          <div class="info_box">
            <h5 v-text="n.game_name"></h5>
            <h3 v-text="n.title"></h3>
            <p :class="{'info-p-jp': $region === 'jp'}" v-text="n.summary"></p>
            <div class="info-bot" :class="{jp: $region === 'jp'}">
              <div class="timeTip">
                <h6>{{$t('active.activeTime')}}</h6>
                <p v-text="getDate(n.begin_time)+' - '+getDate(n.end_time)"></p>
              </div>
              <!-- :href="n.url||'/eventdetail#'+n.activity_id" -->
              <a @click="toDetail({url:n.url, id:n.activity_id})" class="getDetail">
                <span style="vertical-align: middle;">{{$t('active.knowDetail')}}</span>
                <img
                  style="vertical-align: middle;"
                  class="img_g"
                  src="../../../assets/images/news/arrow_right_circle.svg"
                  alt
                />
                <img
                  style="vertical-align: middle;"
                  class="img_w"
                  src="../../../assets/images/news/arrow_right_circle_w.svg"
                  alt
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <a href="#" class="toTop" v-show="totop"></a>
    </div>
  </main>
</template>

<script>
export default {
  name: "active",
  data() {
    return {
      page_num: 1,
      eventList: [],
      have_more: true,
      totop: false
    };
  },
  methods: {
    toDetail(param) {
        this.$router.push({ name: "activeDetailH5", params: { id: param.id } });
    },
    handleScroll() {
      if (
        self.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      ) {
        this.totop = true;
      } else {
        this.totop = false;
      }
    },
    getEvents() {
      this.$apis.home.getEventsList(this.page_num, 20).then(data => {
        let res = data.data;
        // console.log(res)
        if (res.code == 0) {
          if (res.data.length > 0) {
            this.eventList.push(...res.data);
            this.page_num++;
          } else {
            this.have_more = false;
          }
        } else {
          //   console.error(res.message);
        }
      });
    },
    getDate(t) {
      let day = new Date(t.replace(/-/g,"/")).toLocaleDateString();
      return day;
    }
  },
  mounted() {
    // 请求活動
    this.getEvents();
    window.addEventListener("scroll", this.handleScroll);
  }
};
</script>

<style lang="scss" scoped>
div,
p,
h3,
h4,
h5,
h6,
span {
  margin: 0;
  padding: 0;
}
a {
  color: inherit;
  text-decoration: none;
}
.container {
  width: 100%;
  margin: 0 auto;
  min-height: calc(100vh - 1.6rem);
  .tab_title {
    border-bottom: 0.01rem solid #eeeeee;
    text-align: center;
    margin-bottom: 0.4rem;
    hr {
      width: .36rem;
      border: 0;
      height: .04rem;
      background: #a2a2a2;
      position: absolute;
      top: .23rem;
      left: .26rem;
      border-radius: 0.1rem;
      margin: 0.04rem auto 0 auto;
    }
    .cate {
      margin-top:0.58rem;
      display: block;
      position: relative;
      float: left;
      &.jp {
        width: auto;
      }
      p {
        font-size: 0.14rem;
        color: #444444;
        margin-bottom: .12rem;
        margin-left: 0.1rem;
        &.gray {
          color: #bdbdbd;
        }
      }
      .focus_dot {
        width: 0.32rem;
        height: 0.04rem;
        margin: 0.1rem auto -0.02rem auto;
        background: #50BBE5;
        border-radius: 0.1rem;
      }
    }
  }
  .eventsline {
    border-bottom: 0.01rem solid #eeeeee;
    .event_item {
      display: flex;
      align-items: stretch;
      padding: 0.2rem 0;
      overflow: hidden;
      margin-top: -0.02rem;
      border-top: 0.01rem solid #eeee;
      width: 99%;
      .img_box {
        width: 1.4rem;
        height: 0.94rem;
        margin-left: 0.08rem;
        background-color: #444444;
        background-position: center center;
        background-size: 100% 100%;
        flex-grow: 0;
        flex-shrink: 0;
      }
      .info_box {
        flex-grow: 1;
        position: relative;
        margin-left: 0.04rem;
        h5 {
          height: 0.14rem;
          white-space :nowrap;
          text-overflow :ellipsis;
          overflow: hidden;
          font-size: .1rem;
          color: #bdbdbd;
        }
        h3 {
          font-size: 0.12rem;
          color: #444444;
          margin-bottom: 0.04rem;
          margin-left: -0.08rem;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          width: 98%;
        }
        p {
          font-size: 0.1rem;
          color: #999999;
          line-height: 0.16rem;
          height: 0.32rem;
          width: 95%;
          display: block;
          overflow: hidden;
        }
        .getDetail {
          display: block;
          width: 1.2rem;
          height: .3rem;
          line-height: 0.3rem;
          text-align: center;
          border: 0.01rem solid #ddd;
          border-radius: 0.2rem;
          font-size: 0.13rem;
          color: #333333;
          cursor: pointer;
          img {
            width: 0.12rem;
          }
          .img_g {
            display: inline-block;
          }
          .img_w {
            display: none;
          }
        }
        .timeTip {
          position: relative;
          padding-left:0.14rem;
          &::before {
            content: "";
            display: block;
            width: 0.04rem;
            height: 0.3rem;
            border-radius: 0.02rem;
            background: #50bbe5;
            position: absolute;
            top: 0;
            left: 0;
          }
          h6 {
            font-size: .1rem;
            color: #444;
            line-height: .12rem;
          }
          p {
            font-size: .11rem;
            color: #444444;
            line-height: 0.26rem;
          }
        }
      }
    }
  }
  .toTop {
    display: block;
    position: fixed;
    width: 0.42rem;
    height: 0.38rem;
    right: 0.2rem;
    bottom: 0.6rem;
    background: url(../../../assets/images/news/totop_nor.svg) center center no-repeat;
    background-size: contain;
  }
}
</style>
